import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select, Tree } from 'antd';

export interface ICustomerGroupTreeProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  value: string[] | undefined;
  customerGroupList?: Array<GQL.ICustomerGroup>;
  style?: any;
  onChange: (e: any, customerGroup: GQL.ICustomerGroup[] | undefined) => void;
}

export class CustomerGroupTree extends React.PureComponent<ICustomerGroupTreeProps> {

  constructor(props: ICustomerGroupTreeProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, customerGroupList } = this.props;

    if (customerGroupList) {
      return (
        <Tree
          onCheck={(checkedKeys: any, info: any) => this.onChange(checkedKeys.checked, info.node)}
          onSelect={(checkedKeys: any, info: any) => this.onChange(checkedKeys, info.node)}
          selectedKeys={value}
          checkedKeys={value}
          multiple={true}
          checkable={true}
          checkStrictly={true}
          treeData={customerGroupList.map((customerGroup: GQL.ICustomerGroup) => {
            customerGroup.key = customerGroup.id
            customerGroup.title = customerGroup.name
            return customerGroup
          })}
        />
      );
    }

    return (
      <Select placeholder={'Choose customer group'} style={...style} />
    );
  }

  private onChange(value: any, node: any) {
    const { customerGroupList } = this.props;

    const groups = customerGroupList && customerGroupList.filter((g: GQL.ICustomerGroup) => {
      return value.includes(g.id);
    });

    this.props.onChange({
      target: {
        name: this.props.name,
        value,
      }
    }, groups);
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/CustomerGroupTree/CustomerGroupTree.tsx